module.exports = __webpack_public_path__ + "static/media/blank-profile-picture.77f5794e.png";